import React, {useState} from 'react'
import {
    Box,
    Divider,
    IconButton,
    List,
    ListItem,
    ListItemText,
    Typography,
    ClickAwayListener,
    Paper,
} from '@material-ui/core'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import MuiListItemIcon from '@material-ui/core/ListItemIcon'
import {withStyles, makeStyles} from '@material-ui/core/styles'
import {connect} from 'react-redux'
import {userActions} from '../../actions/user.actions'

// Copy Department Virtual Link Icon
import InsertLinkIcon from '@material-ui/icons/InsertLink'

const useStyles = makeStyles(theme => ({
    circle: {
        boxSizing: 'border-box',
        borderRadius: '50%',
        height: '38px',
        width: '38px',
        padding: '1px 1px 1px 1px',
        backgroundColor: '#02AB77',
        '&:hover': {
            opacity: 0.8,
            backgroundColor: '#02AB77',
            transition: 'border-color 0.2s, border-width 0.2s',
        },
    },
    paper: {
        position: 'absolute',
        top: 48,
        right: 5,
        borderRadius: '0px',
        width: '260px',
        whiteSpace: 'normal',
    },
    text: {
        color: '#FFFFFF',
        font: theme.typography.fontFamily,
        fontSize: '0.9rem',
        fontWeight: theme.typography.fontWeightMedium,
    },
}))

const ListItemIcon = withStyles(() => ({
    root: {
        padding: 0,
        minWidth: '2rem',
    },
}))(MuiListItemIcon)

const UserButton = props => {
    const classes = useStyles()
    const {
        firstname,
        lastname,
        activedeptuserrole,
        activedepartment,
        departmentslist,
        userdefaultdept,
        logout,
    } = props

    const initials =
        firstname && lastname ? firstname.charAt(0) + lastname.charAt(0) : ''

    const activedept = activedepartment
        ? departmentslist.find(element => element.deptId === activedepartment)
        : departmentslist.find(element => element.deptId === userdefaultdept[0])

    // for the menu
    const [open, setOpen] = useState(false)

    const handleClick = () => {
        setOpen(!open)
    }

    const handleClose = () => {
        setOpen(false)
    }

    const deptVirtualeventlink =
        process.env.REACT_APP_VIRTUAL_EVENT_APP_URL + `/${activedepartment}`

    const openDeptVirtualEventPage = () => {
        window.open(deptVirtualeventlink, '_blank', 'noopener,noreferrer')
    }

    const logOut = () => {
        try {
            logout('')
        } catch (e) {
            alert(e.message)
        }
    }

    return (
        <>
            <ClickAwayListener onClickAway={handleClose}>
                <div>
                    <IconButton
                        id="user-menu"
                        aria-controls="user-menu"
                        aria-haspopup="true"
                        className={classes.circle}
                        onClick={handleClick}
                    >
                        <Typography
                            variant="body1"
                            align="center"
                            className={classes.text}
                        >
                            {initials.toUpperCase()}
                        </Typography>
                    </IconButton>

                    {open ? (
                        <Paper className={classes.paper}>
                            <Box fontWeight="fontWeightMedium">
                                <List aria-label="user button">
                                    <ListItem>
                                        <ListItemText>
                                            <Typography variant="h6">
                                                {firstname || ''}{' '}
                                                {lastname || ''}
                                            </Typography>
                                            <Box fontWeight="fontWeightBold">
                                                {activedept
                                                    ? activedept.name
                                                    : null}
                                            </Box>
                                            <Box fontWeight="fontWeightMedium">
                                                Role:
                                                {' ' + activedeptuserrole}
                                            </Box>
                                        </ListItemText>
                                    </ListItem>
                                    <Divider />

                                    <ListItem button>
                                        <ListItemIcon>
                                            <InsertLinkIcon />
                                        </ListItemIcon>
                                        <ListItemText>
                                            <Box
                                                fontWeight="fontWeightMedium"
                                                onClick={
                                                    openDeptVirtualEventPage
                                                }
                                            >
                                                Dept Virtual Event Page
                                            </Box>
                                        </ListItemText>
                                    </ListItem>

                                    <ListItem button>
                                        <ListItemIcon>
                                            <ExitToAppIcon />
                                        </ListItemIcon>
                                        <ListItemText>
                                            <Box
                                                fontWeight="fontWeightMedium"
                                                onClick={logOut}
                                            >
                                                Logout
                                            </Box>
                                        </ListItemText>
                                    </ListItem>
                                </List>
                            </Box>
                        </Paper>
                    ) : null}
                </div>
            </ClickAwayListener>
        </>
    )
}

function mapStateToProps(state) {
    return {
        displayname: state.authentication.displayname,
        firstname: state.authentication.firstname,
        lastname: state.authentication.lastname,
        emailaddress: state.authentication.emailAddress,
        euid: state.authentication.euid,
        roles: state.authentication.roles,
        superadmin: state.authentication.admin,
        userdefaultdept: state.authentication.departmentslist,
        activedepartment: state.departmentsdata.activedepartment,
        departmentslist: state.departmentsdata.departmentslist,
        eventlist: state.eventdata.eventlist,
    }
}

const mapDispatchToProps = {
    logout: message => userActions.logout(message),
}

export default connect(mapStateToProps, mapDispatchToProps)(UserButton)
